import { render } from "./AdminRecovery.vue?vue&type=template&id=cb03cf62"
import script from "./AdminRecovery.vue?vue&type=script&lang=js"
export * from "./AdminRecovery.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__